import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { map, size } from 'lodash/fp';
import { Breadcrumb } from 'rsuite';
import Link from '../Link';

const mapWithKey = map.convert({ cap: false });

const LinkItem = props => <Breadcrumb.Item componentClass={Link} {...props} />;

const StyledBreadcrumbs = styled(Breadcrumb)`
  border-bottom: 1px solid #ddd;
  margin-bottom: 0 !important;
  margin-left: 20px;
  padding: 8px 0 !important;
`;

const CustomBreadcrumb = ({ items, ...restProps }) => (
  <StyledBreadcrumbs {...restProps}>
    {mapWithKey(
      (item, i) =>
        i + 1 < size(items) ? (
          <LinkItem key={item.label} to={item.path}>
            {item.label}
          </LinkItem>
        ) : (
          <Breadcrumb.Item key={item.label} active>
            {item.label}
          </Breadcrumb.Item>
        ),
      items
    )}
  </StyledBreadcrumbs>
);

const ItemType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
});

CustomBreadcrumb.propTypes = {
  items: PropTypes.arrayOf(ItemType).isRequired
};

export default CustomBreadcrumb;
